import {useContext, useEffect, useState} from "react";
import { ImageProjectContext } from "../../contexts/imageProject";
import Image from "../global/Image";
import styles from "./index.module.css";
const ProjectImage = () => {
  const { selectedProject, projects, show } = useContext(ImageProjectContext);
  const [opening, setOpening] = useState(false);

  useEffect(() => {
    if(show) {
      setOpening(true);
      setTimeout(() => {
        setOpening(false);
      }, 200);
    }
  }, [show]);

  if (!projects.length) return null;
  return (
    <div
      className={styles.imageContainer}
      style={{ opacity: show ? 1 : 0, transitionDuration: "0.2s", transitionDelay: opening ? "1s" : "0s" }}
    >
      {projects.map((p, i) => {
        return (
          <div
              key={i}
            className={[
              styles.ProjectImageCover,
              i == selectedProject ? styles.displayImage : "",
            ].join(" ")}
          >
            {show && <Image
                key={"image-" + i}
                image={p.image}
                breakpoints={{
                  medium: "0px",
                  large: "800px",
                }}
                alt={p.image?.alt("cover-thumbnail-projet", "Cover")}
                loading="lazy"
            />}

          </div>
        );
      })}
    </div>
  );
};

export default ProjectImage;
